import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import {
  SelectLabel,
  StyledMUIAutoComplete,
} from "../styled/AutoComplete.styled";
import { FormHelperText } from "@mui/material";

export default function CustomAutoComplete({
  label,
  value,
  setValue,
  options,
  setName,
  helperText,
  disabled,
  error,
  onTypeLetters,
  placeholder
}) {
  const [inputValue, setInputValue] = useState("");

  const onInputChange = (newInputValue) => {
    setInputValue(newInputValue);
  };

  const onChange = (newValue) =>{
    let selectedEmail;
    let selectedName;
    options.map((item) => {
      if (item.formattedEmail === newValue || item === newValue) {
        selectedEmail = item.email ? item.email : item;
        selectedName = item.name ? item.name : "";
      }
      return null;
    });
    setValue(selectedEmail);
    setName(selectedName);
  }

  return (
    <div style={{ width: "100% !important" }}>
      <SelectLabel disableAnimation={true} shrink id={label}>
        {label}
      </SelectLabel>
      <StyledMUIAutoComplete
        disabled={disabled}
        value={value}
        fullWidth
        onChange={(event, newValue) => {
          onChange(newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          onInputChange(newInputValue);
          onTypeLetters(newInputValue);
        }}
        id="controllable-states-demo"
        options={inputValue ? options.map((item) => item.formattedEmail ?? item) : []}
        //sx={{ width: 300 }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            fullWidth
            error={error}
            disabled={disabled}
          />
        )}
      />
      <FormHelperText error>{helperText}</FormHelperText>
    </div>
  );
}
